import { render, staticRenderFns } from "./newaddparticulars.vue?vue&type=template&id=cabbe880&scoped=true&"
import script from "./newaddparticulars.vue?vue&type=script&lang=js&"
export * from "./newaddparticulars.vue?vue&type=script&lang=js&"
import style0 from "./newaddparticulars.vue?vue&type=style&index=0&id=cabbe880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabbe880",
  null
  
)

export default component.exports